import * as actions from './extAuth.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { ExtAuthConfigModel } from '@smarttask-common/src/lib/models/Integrations/Auth/ExtAuthConfigModel';

export const configAdapter = createEntityAdapter<ExtAuthConfigModel>({
    selectId: (x) => x.auth_id,
});
export interface ExtAuthConfigState extends EntityState<ExtAuthConfigModel> {
    selected_auth_id: string;
}

export const initialState: ExtAuthConfigState = configAdapter.getInitialState({
    selected_auth_id: undefined,
});

export function ExtAuthConfigReducers(state: ExtAuthConfigState = initialState, action: actions.ExtAuthConfigActions) {
    switch (action.type) {
        case actions.ExtAuthConfigActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_auth_id: action.selected_auth_id };
            return state;

        case actions.ExtAuthConfigActionTypes.ADD_EXT_AUTH_CONFIG:
            return configAdapter.addOne(action.config, state);

        case actions.ExtAuthConfigActionTypes.ADD_EXT_AUTH_CONFIGS:
            return configAdapter.addMany(action.configs, state);

        case actions.ExtAuthConfigActionTypes.UPSERT_EXT_AUTH_CONFIG:
            return configAdapter.upsertOne(action.config, state);

        case actions.ExtAuthConfigActionTypes.UPSERT_EXT_AUTH_CONFIGS:
            return configAdapter.upsertMany(action.configs, state);

        case actions.ExtAuthConfigActionTypes.UPDATE_EXT_AUTH_CONFIG:
            return configAdapter.updateOne(action.config, state);

        case actions.ExtAuthConfigActionTypes.UPDATE_EXT_AUTH_CONFIGS:
            return configAdapter.updateMany(action.configs, state);

        case actions.ExtAuthConfigActionTypes.DELETE_EXT_AUTH_CONFIG:
            return configAdapter.removeOne(action.auth_id, state);

        case actions.ExtAuthConfigActionTypes.DELETE_EXT_AUTH_CONFIGS:
            return configAdapter.removeMany(action.auth_ids, state);

        case actions.ExtAuthConfigActionTypes.DELETE_ALL_EXT_AUTH_CONFIGS:
            return configAdapter.removeMany(action.auth_ids, state);

        case actions.ExtAuthConfigActionTypes.DELETE_ALL:
            return configAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getExtAuthConfigState = createFeatureSelector<ExtAuthConfigState>('extAuthConfig');

export const { selectIds, selectEntities, selectAll, selectTotal } = configAdapter.getSelectors(getExtAuthConfigState);

const getSelectedAuthIdState = (state: ExtAuthConfigState) => {
    return state.selected_auth_id;
};
export const getSelectedAuthId = createSelector(getExtAuthConfigState, getSelectedAuthIdState);

export const getSelectedConfig = createSelector(getExtAuthConfigState, (state: ExtAuthConfigState) => {
    if (state.selected_auth_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_auth_id];
});
